// @flow
import React from 'react'
import Tr from '../../../../components/Tr'
import Td from '../../../../components/Td'
import Button from '../../../../components/Button'

type Props = {
  alert: Object,
  onDelete: Function,
  onOpenEditModal: Function
}

const AlertRow = ({ alert, onOpenEditModal, onDelete }: Props) => (
  <Tr>
    <Td>{alert.keyword}</Td>
    <Td>
      ${Number(alert.minprice).toLocaleString()}&nbsp;- $
      {Number(alert.maxprice).toLocaleString()}
    </Td>
    <Td>{alert.minbeds} +</Td>
    <Td>{alert.minbaths} +</Td>
    <Td>{alert.minarea} +</Td>
    <Td style={{ textAlign: 'right' }}>
      <Button
        onClick={() => onOpenEditModal(alert)}
        style={{ marginRight: '8px' }}
      >
        <span className="fa fa-pencil" />
      </Button>
      <Button onClick={() => onDelete(alert)} color="danger">
        <span className="fa fa-trash" />
      </Button>
    </Td>
  </Tr>
)

export default AlertRow



// WEBPACK FOOTER //
// ./src/views/UserSearches/components/AlertRow/index.js